export default __webpack_public_path__ + "img/bestOfBsp.41cf5788.png";